module.exports = "/_next/static/images/CollectDataTabs-1-lg-cbe9054fbd569e12f2c00239512918b9.webp";